import { render } from "./About.vue?vue&type=template&id=d007c5aa&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=d007c5aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d007c5aa"

export default script